import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { ReleaseDto } from '../dtos/release.dto';
import { ReleaseModel } from '../models/release.model';
import { mapReleaseDtoToReleaseModel } from '../utils/releases-mapping.utils';

export const deleteAppRelease: AsyncThunk<
  ReleaseModel,
  number,
  Record<number, unknown>
> = createAsyncThunk(
  'app/releases/delete-app-releases',
  async (appId: number) => {
    const basePath = `/apps/releases/${appId}`;
    const resp: AxiosResponse<ReleaseDto> = await axiosInstance.delete(
      basePath
    );
    return mapReleaseDtoToReleaseModel(resp.data);
  }
);
